/* jshint esversion: 6 */

export const LmsErrorCodes = {

    e0: "No Error",

    // General Error Codes
    e1: "Unspecified General Error",
    e101: "General Exception",
    e102: "General Initialization Failure",
    e103: "Already Initialized",
    e104: "Content Instance Terminated",
    e111: "General Termination Failure",
    e112: "Termination Before Initialization",
    e113: "Termination After Termination",
    e122: "Retrieve Data Before Initialization",
    e123: "Retrieve Data After Termination",
    e132: "Store Data Before Initialization",
    e133: "Store Data After Termination",
    e142: "Commit Before Initialization",
    e143: "Commit Data After Termination",

    // Syntax Errors Codes
    e2: "Unspecified Syntax Error",
    e201: "General Argument Error",
    e202: "Element cannot have children",
    e203: "Element not an array - cannot have count",

    // LMS Error Codes
    e3: "Unspecified LMS Error",
    e301: "General Get Failure",
    e351: "General Set Failure",
    e391: "General Commit Failure",

    // Data Model Error Codes
    e4: "Unspecified Data Model Error",
    e401: "Undefined Data Model Element",
    e402: "Unimplemented Data Model Element",
    e403: "Data Model Element Value Not Initialized",
    e404: "Data Model Element Is Read Only",
    e405: "Data Model Element Is Write Only",
    e406: "Data Model Element Type Mismatch",
    e407: "Data Model Element Value Out Of Range",
    e408: "Data Model Dependency Not Established"
};

export function getLMSErrorMessage(errorCode) {

    let mapCodeId = `e${errorCode.toString()}`;
    if (typeof (LmsErrorCodes[mapCodeId]) !== "undefined") {
        return LmsErrorCodes[mapCodeId];
    }

    mapCodeId = `e${errorCode.toString().substr(0, 1)}`;
    if (typeof (LmsErrorCodes[mapCodeId]) !== "undefined") {
        return LmsErrorCodes[mapCodeId];
    }

    return "Unspecified error";
}
